import { useEffect, useState } from "react";
import api from "@/lib/api";

// Lit le contenu CMS public /api/pages/{key} et fusionne les valeurs non vides
// par-dessus le texte de repli (fallback) fourni par la page.
export function usePage(key, fallback = {}) {
  const [content, setContent] = useState(fallback);
  const [exists, setExists] = useState(true);
  useEffect(() => {
    let ok = true;
    setContent(fallback);
    setExists(true);
    api.get(`/pages/${key}`).then(({ data }) => {
      if (!ok) return;
      setExists(data?.exists !== false);
      const c = data?.content || {};
      const merged = { ...fallback };
      Object.keys(c).forEach((k) => {
        if (c[k] !== "" && c[k] != null) merged[k] = c[k];
      });
      setContent(merged);
    }).catch(() => {});
    return () => { ok = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  return { content, exists };
}
